// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1MBQZ","productName":"Table_productName__32YWK"};